<template>
  <div id="GoTop" @click="GoTop()">
    <ul class="right_nav">
      <li>
        <div class="iconBox oln_ser">
          <img src="../assets/image/tel123.jpg" />
          <h4>Phone</h4>
        </div>
        <div class="hideBox">
          <div class="hb">
            <h5>Phone</h5>
            <div class="fonttalk">
              <p><a href="tel:+86 2865988164">+86 193 8197 8621</a></p>
            </div>
            <div class="fonttalk"></div>
          </div>
        </div>
      </li>

      <li>
        <div class="iconBox oln_ser">
          <img src="../assets/image/email123.jpg" />
          <h4>E-mail</h4>
        </div>
        <div class="hideBox">
          <div class="hb">
            <h5>E-mail</h5>
            <div class="fonttalk">
              <p><a href="mailto:info@leacree.com">info@kintop-tech.com</a></p>
            </div>
            <div class="fonttalk"></div>
          </div>
        </div>
      </li>

      <li>
        <div class="iconBox oln_ser">
          <img src="../assets/image/whatsapp123.jpg" />
          <h4>WhatsApp</h4>
        </div>
        <div class="hideBox">
          <div class="hb">
            <h5>WhatsApp</h5>
            <div class="fonttalk">
              <p>
                <a href="https://api.whatsapp.com/send?phone=8613540840846">+86 193 8197 8621</a>
              </p>
            </div>
            <div class="fonttalk"></div>
          </div>
        </div>
      </li>

      <li>
        <div class="iconBox oln_ser">
          <img src="../assets/image/skype123.jpg" />
          <h4>skype</h4>
        </div>
        <div class="hideBox">
          <div class="hb">
            <h5>skype</h5>
            <div class="fonttalk">
              <p><a href="skype:info@leacree.com?chat">info@kintop-tech.com</a></p>
            </div>
            <div class="fonttalk"></div>
          </div>
        </div>
      </li>

      <li>
        <div class="iconBox oln_ser">
          <img src="../assets/image/weixing123.png" />
          <h4>WeChat</h4>
        </div>
        <div class="hideBox">
          <div class="hb">
            <h5>WeChat</h5>
            <div class="fonttalk">
              <p>
                <a><img src="../assets/image/wechat111.png" /></a>
              </p>
            </div>
            <div class="fonttalk"></div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script >
export default {
  name: "GoTop",
  data() {
    return {
      flag: false
    };
  },
  mounted() {
    //右侧导航伸缩效果  js
    var right_nav = $(".right_nav");
    var tempS;

    $(".right_nav li").each(function () {
      $(this).mouseenter(function () {
        $(this).animate(
          {
            right: "0"
          },
          300
        );
      });
      $(this).mouseleave(function () {
        $(this).animate(
          {
            right: "-85"
          },
          100
        );
      });
    });

    //右侧导航点击事件  js
    $(".right_nav li").each(function (i) {
      //若需要添加版块，请添加if条件
      var j = $(".right_nav li").length - 1;
      $(this).mouseover(function () {
        $(this).children(".hideBox").stop().fadeIn();
        right_nav.css("overflow", "visible");
      });
      $(this).mouseout(function () {
        $(this).children(".hideBox").hide();
        right_nav.css("overflow", "hidden");
      });

    });
  },
  methods: {
    GoTop() {
      (function smoothscroll() {
        var currentScroll =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (currentScroll > 0) {
          window.requestAnimationFrame(smoothscroll);
          window.scrollTo(0, currentScroll - currentScroll / 10);
        }
      })();
    }
  }
};
</script>
<style scoped>
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  outline: 0;
  -ms-box-sizing: border-box;
  -o-box-sizing: border-box;
}

li {
  list-style: none;
}

a {
  color: #333;
  text-decoration: none;
}

.right_nav {
  right: 0;
  bottom: 50%;
  position: fixed;
  text-align: left;
  overflow: hidden;
  z-index: 999999;
  /*background-color: #3c9ba6;*/
  border-radius: 25px 0 0 25px;
  transform: translateY(50%);
}

.right_nav li {
  background: #fb7707;
  margin: 4px 0;
  padding: 10px;
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  cursor: pointer;
  position: relative;
  border-radius: 50px 0 0 50px;
  right: -85px;
}

.right_nav li .iconBox {
  text-align: center;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.right_nav .iconBox>img {
  width: 45px;
  height: 45px;
  background-color: white;
  border-radius: 50%;
  padding: 7%;
}

.right_nav li h4 {
  color: #fff;
  font-size: 12px;
  margin: 2px 0;
  margin-left: 5px;
}

.right_nav li:hover {
  background: blue;
}

.right_nav li .hideBox {
  display: none;
  position: absolute;
  right: 120px;
  padding: 10px;
  padding-right: 28px;
  top: -10px;
  z-index: 999;
  opacity: 1 !important;
  width: max-content;
}

.right_nav li .hideBox .hb {
  border: 1px solid #ccc;
  background-color: #fff;
  padding: 10px 20px;
  border-top: 2px solid #f39700;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  float: left;
}

.right_nav li .hideBox .hb h5 {
  text-align: center;
  padding: 5px 0;
  border-bottom: 2px solid #ccc;
  color: #f39700;
  font-size: 16px;
  font-weight: 400;
  display: block;
  white-space: nowrap;
  display: none;
}

.right_nav li .hideBox .hb p {
  margin-top: 5px;
  font-size: 18px;
  font-weight: 700;
}

.right_nav li .hideBox .hb .fonttalk {
  margin-top: 10px;
}

.right_nav li .hideBox .hb .fonttalk a {
  display: flex;
  align-items: center;
}

.right_nav li .hideBox .hb .fonttalk img {
  width: 200px;
  height: 240px;
  margin: -10px;
}

.right_nav li .hideBox .hb .fonttalk p {
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  margin-top: -5px;
  margin-left: 5px;
}

.right_nav li .hideBox img {
  width: 140px;
  height: 140px;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/GoTop.vue